<template>
  <!--Page Header-->
  <section
    id="main-banner-page"
    class="position-relative page-header section-nav-smooth parallax blog-detail-header"
    style="background-image: url('img/night.jpeg')"
  >
    <!-- <div class="overlay overlay-dark opacity-8 z-index-1"></div> -->
    <div class="container">
      <div class="row">
        <div class="col-lg-6">
          <div class="page-titles whitecolor text-center padding_top">
            <!-- <h2 class="font-bold text-color-main">Mobil Listrik</h2> -->
          </div>
        </div>
      </div>
      <div class="title-wrap bg-custom">
        <div class="row">
          <div class="col-lg-12 col-md-12 whitecolor">
            <h3 class="float-left">Peraturan</h3>
            <ul class="breadcrumb top10 bottom10 float-right">
              <li class="breadcrumb-item"><a href="/">Beranda</a></li>
              <li class="breadcrumb-item">Peraturan</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!--Page Header ends -->
  <!-- Our Blogs -->
  <section
    id="our-blog"
    class="bglight padding_top padding_bottom_half"
    style="
      background-image: url('fe/asset/img/big-bg-white.png');
      background-size: cover;
      border-radius: 10px !important;
    "
  >
    <b-overlay :show="isLoading" rounded="sm">
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <div class="news_item shadow-equal">
              <div
                class="news_desc text-center text-md-left"
                style="
                  background-color: #fff !important;
                  background-image: none !important;
                "
              >
                <div class="mt-0 mb-5">
                  <h4 class="text-dark">
                    Informasi Peraturan Kementerian Energi dan Sumber Daya
                    Mineral
                  </h4>
                </div>
                <div class="row">
                  <div class="col-md-4">
                    <input
                      type="text"
                      v-model="search"
                      v-debounce:200ms="searchItems"
                      class="form-control form-control-solid w-250px ps-15"
                      placeholder="Cari..."
                    />
                  </div>
                  <div class="col-md-4">
                    <select
                      name=""
                      class="form-control"
                      @change="handleCategoryChange($event)"
                    >
                      <option value="">Semua Kategori</option>
                      <option
                        v-for="item in rulesCategoryList"
                        :key="item"
                        :value="item.id"
                      >
                        {{ item.name }}
                      </option>
                    </select>
                  </div>
                  <div class="col-md-4">
                    <select
                      name=""
                      class="form-control"
                      @change="handleTahunChange($event)"
                    >
                      <option value="">Semua Tahun</option>
                      <option
                        v-for="item in listTahun"
                        :key="item"
                        :value="item"
                      >
                        {{ item }}
                      </option>
                    </select>
                  </div>
                </div>
                <Datatable
                  @on-sort="sort"
                  @on-items-per-page-change="itemsPerPageChange"
                  @page-change="pageChange"
                  :data="rulesList"
                  :header="tableHeader"
                  :enable-items-per-page-dropdown="true"
                  :total="rulesMeta.total_data"
                  :itemsPerPage="10"
                  empty-table-text="Tidak ada data"
                >
                  <template v-slot:id="{ row }">
                    {{
                      rulesList.indexOf(row) +
                      1 +
                      (rulesMeta.page - 1) * rulesMeta.limit
                    }}.
                  </template>
                  <template v-slot:tahun_terbit="{ row: rulesList }">
                    {{ rulesList.tahun_terbit }}
                  </template>
                  <template v-slot:category_id="{ row: rulesList }">
                    {{ rulesList.category.name }}
                  </template>
                  <template v-slot:title="{ row: rulesList }">
                    {{ rulesList.title }}
                  </template>
                  <template v-slot:actions="{ row: rulesList }">
                    <a
                      target="_blank"
                      :href="getFilePath('rules-doc', rulesList.document)"
                      class="btn btn-sm btn-secondary"
                    >
                      <i class="bi bi-file-earmark-arrow-down-fill"></i>
                      Download PDF
                    </a>
                  </template>
                </Datatable>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-overlay>
  </section>
  <!--Our Blog Ends-->
</template>

<script lang="ts">
import { defineComponent, onMounted, reactive, ref } from "vue";
import Datatable from "@/components/kt-datatable/KTDataTable.vue";
import type { Sort } from "@/components/kt-datatable//table-partials/models";
import { useCmsStores } from "@/store/cms";
import { getFilePath } from "@/core/helpers/assets";

export default defineComponent({
  components: {
    Datatable,
  },
  setup() {
    const tableHeader = ref([
      {
        columnName: "No",
        columnLabel: "id",
        sortEnabled: true,
        columnWidth: 40,
      },
      {
        columnName: "Tahun",
        columnLabel: "tahun_terbit",
        sortEnabled: true,
        columnWidth: 100,
      },
      {
        columnName: "Kategori",
        columnLabel: "category_id",
        sortEnabled: false,
        columnWidth: 175,
      },
      {
        columnName: "Judul",
        columnLabel: "title",
        sortEnabled: true,
        columnWidth: 300,
      },
      {
        columnName: "Aksi",
        columnLabel: "actions",
        sortEnabled: false,
        columnWidth: 60,
      },
    ]);

    const queryParams = reactive({
      is_public: true,
      limit: 10,
      page: 1,
      sort: "asc",
      orderBy: "id",
      with_users: true,
      category_id: "",
      keyword: "",
      tahun_terbit: "",
      status : 'published'
    });

    const cmsStore = useCmsStores();
    const rulesList = ref([]);
    const rulesMeta = reactive({
      limit: 10,
      offset: 0,
      page: 1,
      total_data: 0,
    });
    const rulesCategoryList = ref([]);
    const isLoading = ref(false);
    const listTahun = ref([]);

    // get tahun 5 tahun terakhir dan 5 tahun ke depan
    const getTahun = () => {
      const date = new Date();
      const tahun = date.getFullYear();
      const tahunAwal = tahun - 7;
      const tahunAkhir = tahun;

      for (let i = tahunAwal; i <= tahunAkhir; i++) {
        listTahun.value.push(i);
      }
    };

    const getRules = async () => {
      await cmsStore.getRules(queryParams).then((res) => {
        rulesList.value = res.data.data.data;
        rulesMeta.limit = res.data.data.limit;
        rulesMeta.offset = res.data.data.offset;
        rulesMeta.page = res.data.data.page;
        rulesMeta.total_data = res.data.data.total_data;
      });
    };

    const getRulesCategory = async () => {
      const p = {
        is_public : true
      }
      await cmsStore.getRulesCategory(p).then((res) => {
        rulesCategoryList.value = res.data.data;
      });
    };

    const search = ref<string>("");
    const searchItems = async () => {
      if (search.value !== "") {
        queryParams.keyword = search.value;
      } else {
        queryParams.keyword = "";
      }

      await getRules();
    };

    const sort = async (sort: Sort) => {
      queryParams.sort = sort.order;
      queryParams.orderBy = sort.label ?? "sort";

      isLoading.value = true;
      await getRules();
      isLoading.value = false;
    };

    const itemsPerPageChange = async (page: number) => {
      queryParams.limit = page;

      isLoading.value = true;
      await getRules();
      isLoading.value = false;
    };

    const pageChange = async (page: number) => {
      queryParams.page = page;

      isLoading.value = true;
      await getRules();
      isLoading.value = false;
    };

    const handleCategoryChange = async (event: any) => {
      queryParams.category_id = event.target.value;

      isLoading.value = true;
      await getRules();
      isLoading.value = false;
    };

    const handleTahunChange = async (event: any) => {
      queryParams.tahun_terbit = event.target.value;

      isLoading.value = true;
      await getRules();
      isLoading.value = false;
    };

    onMounted(async () => {
      isLoading.value = true;
      getTahun();
      await getRulesCategory();
      await getRules();
      isLoading.value = false;
    });

    return {
      tableHeader,
      queryParams,
      rulesList,
      rulesMeta,
      isLoading,
      search,
      searchItems,
      sort,
      itemsPerPageChange,
      pageChange,
      getFilePath,
      rulesCategoryList,
      listTahun,
      handleCategoryChange,
      handleTahunChange,
    };
  },
});
</script>
